export enum LabSpecimenTypeEnum {
  Blood = 1,
  Urine = 2,
  Stool = 3,
  Swab = 4,
  Breath = 5
}

export const LabSpecimenTypeOptions = [
{ id: 1, label: 'Blood' },
{ id: 2, label: 'Urine' },
{ id: 3, label: 'Stool' },
{ id: 4, label: 'Swab / Source' },
{ id: 5, label: 'Breath' }
];
